/*
Hook designed to fetch and display filed emails on the MS Graph service.
*/

import toast from "react-hot-toast";
import { FiledEmailType } from "../types/EmailType";
import { openEmailPreviewModel } from "../components/modals/email-preview-modal";
import { useLazyGetFiledMailByGraphIdQuery } from "../services/useremails";

export type OpenFiledEmailHookProps = {
    openPreviewModal: (graphId: string) => Promise<void>
};

export const useOpenFiledEmail = () : OpenFiledEmailHookProps => {
    const [getFiledEmail, opts] = useLazyGetFiledMailByGraphIdQuery();

    const handleOpenPreviewModal = (graphId: string) : Promise<void> => new Promise<void>((resolve, reject) => {
        return toast.promise<FiledEmailType>(getFiledEmail({ graphId }).unwrap(), {
            loading: 'Attempting to get email data...',
            success: null,
            error: (err) => err?.message ?? 'There was a problem getting the email data from the server.'
        }).then(
            (data: FiledEmailType) => openEmailPreviewModel(data).then(resolve, reject),
            (e) => reject(e)
        );
    });
    
    return {
        openPreviewModal: handleOpenPreviewModal
    };
};